import { FiGlobe, FiTarget } from "react-icons/fi";

const compact = new Intl.NumberFormat("en", { notation: "compact" });

const styles = {
    sky: "bg-sky-100 text-sky-600",
    violet: "bg-violet-100 text-violet-600",
};

const Card = ({ icon, title, value, visitors, payments, accent }) => (
    <div className="flex items-center gap-3 rounded-lg bg-white/70 p-4 ring-1 ring-slate-100">
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${styles[accent]}`}>
            {icon}
        </div>

        <div className="min-w-0">
            <p className="text-[11px] font-medium uppercase tracking-wide text-slate-400">
                {title}
            </p>
            <h3 className="truncate text-base font-semibold text-slate-900">
                {value || "-"}
            </h3>
            <p className="text-xs text-slate-500">
                {compact.format(visitors || 0)} visitors • {compact.format(payments || 0)} payments
            </p>
        </div>
    </div>
);

const MarketingOverview = ({ summary }) => {
    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-indigo-50/50 via-white to-sky-50/40 p-5">
            <h2 className="text-base font-semibold text-slate-900">Marketing Overview</h2>
            <p className="mb-4 mt-0.5 text-xs text-slate-500">Highest performing acquisition channels</p>

            <div className="grid gap-3 md:grid-cols-2">
                <Card
                    icon={<FiGlobe size={18} />}
                    title="Top Traffic Source"
                    value={summary?.top_source?.source}
                    visitors={summary?.top_source?.visitors}
                    payments={summary?.top_source?.payments}
                    accent="sky"
                />
                <Card
                    icon={<FiTarget size={18} />}
                    title="Top Campaign"
                    value={summary?.top_campaign?.campaign}
                    visitors={summary?.top_campaign?.visitors}
                    payments={summary?.top_campaign?.payments}
                    accent="violet"
                />
            </div>
        </div>
    );
};

export default MarketingOverview;